import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const CloseIcon = observer('CloseIcon', ({ className, onClick }: SvgIconPropsType): JSX.Element => {
    return (
        <SvgIcon
            className={className}
            data-test='close-icon'
            fillRule='evenodd'
            height='24'
            onClick={onClick}
            viewBox='0 0 24 24'
            width='24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='currentcolor'
                fillRule='evenodd'
                d='M20 5.6 18.4 4 12 10.4 5.6 4 4 5.6l6.4 6.4L4 18.4 5.6 20l6.4-6.4 6.4 6.4 1.6-1.6-6.4-6.4L20 5.6Z'
                clipRule='evenodd'
            />
        </SvgIcon>
    );
});
